var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContainer3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1793.308,
    height: 940.435,
    viewBox: "0 0 1793.308 940.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42069",
    "data-name": "Group 42069",
    transform: "translate(-78.336 -2203.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42064",
    "data-name": "Group 42064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7008",
    "data-name": "Path 7008",
    d: "M27.537,156a3.959,3.959,0,0,0,3.96-3.96v-3.96h3.96a3.96,3.96,0,1,0,0-7.921H31.5V136.2a3.96,3.96,0,1,0-7.921,0v3.96h-3.96a3.96,3.96,0,1,0,0,7.921h3.96v3.96A3.959,3.959,0,0,0,27.537,156Z",
    transform: "translate(1705.024 2980.659)",
    fill: "#9192ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    d: "M27.537,156a3.959,3.959,0,0,0,3.96-3.96v-3.96h3.96a3.96,3.96,0,1,0,0-7.921H31.5V136.2a3.96,3.96,0,1,0-7.921,0v3.96h-3.96a3.96,3.96,0,1,0,0,7.921h3.96v3.96A3.959,3.959,0,0,0,27.537,156Z",
    transform: "translate(1264.344 2980.659)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7009",
    "data-name": "Path 7009",
    d: "M27.537,156a3.959,3.959,0,0,0,3.96-3.96v-3.96h3.96a3.96,3.96,0,1,0,0-7.921H31.5V136.2a3.96,3.96,0,1,0-7.921,0v3.96h-3.96a3.96,3.96,0,1,0,0,7.921h3.96v3.96A3.959,3.959,0,0,0,27.537,156Z",
    transform: "translate(1516.464 2468.523)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42059",
    "data-name": "Group 42059",
    transform: "translate(1582.882 2959.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M143.656,16.12A11.881,11.881,0,1,0,155.537,4.239,11.9,11.9,0,0,0,143.656,16.12Zm15.841,0a3.96,3.96,0,1,1-3.96-3.96A3.964,3.964,0,0,1,159.5,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42061",
    "data-name": "Group 42061",
    transform: "translate(1847.882 2748.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-2",
    "data-name": "Path 2356",
    d: "M143.656,16.12A11.881,11.881,0,1,0,155.537,4.239,11.9,11.9,0,0,0,143.656,16.12Zm15.841,0a3.96,3.96,0,1,1-3.96-3.96A3.964,3.964,0,0,1,159.5,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42063",
    "data-name": "Group 42063",
    transform: "translate(1439.882 2387.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-3",
    "data-name": "Path 2356",
    d: "M143.656,16.12A11.881,11.881,0,1,0,155.537,4.239,11.9,11.9,0,0,0,143.656,16.12Zm15.841,0a3.96,3.96,0,1,1-3.96-3.96A3.964,3.964,0,0,1,159.5,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42068",
    "data-name": "Group 42068",
    transform: "translate(948.119 2387.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-4",
    "data-name": "Path 2356",
    d: "M143.656,16.12A11.881,11.881,0,1,0,155.537,4.239,11.9,11.9,0,0,0,143.656,16.12Zm15.841,0a3.96,3.96,0,1,1-3.96-3.96A3.964,3.964,0,0,1,159.5,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42056",
    "data-name": "Group 42056",
    transform: "translate(1712.476 2203.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-5",
    "data-name": "Path 2356",
    d: "M143.656,16.12A11.881,11.881,0,1,0,155.537,4.239,11.9,11.9,0,0,0,143.656,16.12Zm15.841,0a3.96,3.96,0,1,1-3.96-3.96A3.964,3.964,0,0,1,159.5,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42053",
    "data-name": "Group 42053",
    transform: "translate(1406.015 2211.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M320.571,125.969a2.379,2.379,0,0,1-1.688-.7l-5.391-5.391a2.386,2.386,0,0,1,0-3.376l5.391-5.391a2.387,2.387,0,0,1,3.376,0l5.391,5.391a2.387,2.387,0,0,1,0,3.376l-5.391,5.391A2.379,2.379,0,0,1,320.571,125.969Zm-2.015-7.779,2.015,2.015,2.015-2.015-2.015-2.015Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#d1d1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42055",
    "data-name": "Group 42055",
    transform: "translate(1744.442 2585.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375-2",
    "data-name": "Path 2375",
    d: "M320.571,125.969a2.379,2.379,0,0,1-1.688-.7l-5.391-5.391a2.386,2.386,0,0,1,0-3.376l5.391-5.391a2.387,2.387,0,0,1,3.376,0l5.391,5.391a2.387,2.387,0,0,1,0,3.376l-5.391,5.391A2.379,2.379,0,0,1,320.571,125.969Zm-2.015-7.779,2.015,2.015,2.015-2.015-2.015-2.015Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42060",
    "data-name": "Group 42060",
    transform: "translate(1372.352 2830.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M50.194,333.205a2.388,2.388,0,0,1-1.688-.7l-5.391-5.391a2.386,2.386,0,0,1,0-3.376l5.391-5.391a2.387,2.387,0,0,1,3.376,0l5.391,5.391a2.387,2.387,0,0,1,0,3.376l-5.391,5.392A2.387,2.387,0,0,1,50.194,333.205Zm-2.016-7.779,2.015,2.016,2.015-2.016-2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42062",
    "data-name": "Group 42062",
    transform: "translate(1847.882 2287.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-2",
    "data-name": "Path 2376",
    d: "M50.194,333.205a2.388,2.388,0,0,1-1.688-.7l-5.391-5.391a2.386,2.386,0,0,1,0-3.376l5.391-5.391a2.387,2.387,0,0,1,3.376,0l5.391,5.391a2.387,2.387,0,0,1,0,3.376l-5.391,5.392A2.387,2.387,0,0,1,50.194,333.205Zm-2.016-7.779,2.015,2.016,2.015-2.016-2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42058",
    "data-name": "Group 42058",
    transform: "translate(1258.336 2506.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-3",
    "data-name": "Path 2376",
    d: "M50.194,333.205a2.388,2.388,0,0,1-1.688-.7l-5.391-5.391a2.386,2.386,0,0,1,0-3.376l5.391-5.391a2.387,2.387,0,0,1,3.376,0l5.391,5.391a2.387,2.387,0,0,1,0,3.376l-5.391,5.392A2.387,2.387,0,0,1,50.194,333.205Zm-2.016-7.779,2.015,2.016,2.015-2.016-2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42065",
    "data-name": "Group 42065",
    transform: "translate(78.336 2210.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7008-2",
    "data-name": "Path 7008",
    d: "M27.537,156a3.959,3.959,0,0,1-3.96-3.96v-3.96h-3.96a3.96,3.96,0,1,1,0-7.921h3.96V136.2a3.96,3.96,0,1,1,7.921,0v3.96h3.96a3.96,3.96,0,1,1,0,7.921H31.5v3.96A3.959,3.959,0,0,1,27.537,156Z",
    transform: "translate(111.545 777.395)",
    fill: "#9192ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7009-2",
    "data-name": "Path 7009",
    d: "M27.537,156a3.959,3.959,0,0,1-3.96-3.96v-3.96h-3.96a3.96,3.96,0,1,1,0-7.921h3.96V136.2a3.96,3.96,0,1,1,7.921,0v3.96h3.96a3.96,3.96,0,1,1,0,7.921H31.5v3.96A3.959,3.959,0,0,1,27.537,156Z",
    transform: "translate(300.106 265.259)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42059-2",
    "data-name": "Group 42059",
    transform: "translate(265 755.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-6",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42061-2",
    "data-name": "Group 42061",
    transform: "translate(0 544.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-7",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42063-2",
    "data-name": "Group 42063",
    transform: "translate(408 183.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-8",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42066",
    "data-name": "Group 42066",
    transform: "translate(567.882 909.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-9",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42056-2",
    "data-name": "Group 42056",
    transform: "translate(135.406 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-10",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42053-2",
    "data-name": "Group 42053",
    transform: "translate(450.072 8.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375-3",
    "data-name": "Path 2375",
    d: "M320.57,125.969a2.379,2.379,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.391A2.379,2.379,0,0,0,320.57,125.969Zm2.015-7.779-2.015,2.015-2.015-2.015,2.015-2.015Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#d1d1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42055-2",
    "data-name": "Group 42055",
    transform: "translate(111.644 381.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375-4",
    "data-name": "Path 2375",
    d: "M320.57,125.969a2.379,2.379,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.391A2.379,2.379,0,0,0,320.57,125.969Zm2.015-7.779-2.015,2.015-2.015-2.015,2.015-2.015Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42060-2",
    "data-name": "Group 42060",
    transform: "translate(483.735 627.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-4",
    "data-name": "Path 2376",
    d: "M50.193,333.205a2.388,2.388,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.392A2.387,2.387,0,0,0,50.193,333.205Zm2.016-7.779-2.015,2.016-2.015-2.016,2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42062-2",
    "data-name": "Group 42062",
    transform: "translate(8.204 84.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-5",
    "data-name": "Path 2376",
    d: "M50.193,333.205a2.388,2.388,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.392A2.387,2.387,0,0,0,50.193,333.205Zm2.016-7.779-2.015,2.016-2.015-2.016,2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42058-2",
    "data-name": "Group 42058",
    transform: "translate(597.75 303.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-6",
    "data-name": "Path 2376",
    d: "M50.193,333.205a2.388,2.388,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.392A2.387,2.387,0,0,0,50.193,333.205Zm2.016-7.779-2.015,2.016-2.015-2.016,2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42067",
    "data-name": "Group 42067",
    transform: "translate(938.75 913.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-7",
    "data-name": "Path 2376",
    d: "M50.193,333.205a2.388,2.388,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.392A2.387,2.387,0,0,0,50.193,333.205Zm2.016-7.779-2.015,2.016-2.015-2.016,2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer3);
export default __webpack_public_path__ + "static/media/container3.ff720db87f9b11eb02e95f1cd2a471f9.svg";
export { ForwardRef as ReactComponent };